<template>
   <Loading :isLoading="caseLoading">
  <v-layout
    row wrap fluid class="homepage-card-container metric-panel"
     >
      
  </v-layout>
  </Loading>
</template>

<script>
import { mapState } from 'vuex'
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "MetricPanel",
  components: { Loading },
  data: () => ({ userLoading: false }),
  computed: {
    ...mapState({
      caseLoading: state => state.homepage.metricsLoading,
      items: state => state.homepage.metrics
    })
  }
}
</script>
